import { EVENT } from "../config";

export default function Footer() {
  return (
    <footer className="py-24 border-t border-white/5 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-16">
          {/* Giant watermark */}
          <div className="w-full md:w-2/3">
            <h2 className="text-[15vw] md:text-[12vw] leading-[0.7] tracking-tighter text-white/[0.03] font-serif font-bold select-none pointer-events-none uppercase">
              Daaru Desi.
            </h2>
          </div>

          <div className="flex flex-col gap-10 md:text-right">
            <div className="flex flex-col gap-4">
              <a
                href={EVENT.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors tracking-widest uppercase text-xs cursor-pointer"
              >
                Instagram
              </a>
              <a href="#tickets" className="text-gray-400 hover:text-white transition-colors tracking-widest uppercase text-xs cursor-pointer">
                Tickets
              </a>
              <a href="#venue" className="text-gray-400 hover:text-white transition-colors tracking-widest uppercase text-xs cursor-pointer">
                Venue
              </a>
            </div>
            <div className="space-y-2">
              <p className="text-white/40 text-xs tracking-widest uppercase">
                &copy; 2026 Daaru Desi Events
              </p>
              <p className="text-white/20 text-[10px] tracking-widest uppercase">
                Where Culture Meets the Night
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
